module.exports = __webpack_public_path__ + "img/icon-close.83081a64.svg";